export default __webpack_public_path__ + "static/invoicing-automation-f70758446868a341ec723ad974a4e04e.png";